import React, { Component } from 'react'
import { HeaderView } from '@merchant-backend/common-components'
import Home from './Home'
export default class extends Component {
  render() {
    return (
      <HeaderView>
        <Home />
      </HeaderView>
    )
  }
}
